
































import Vue from 'vue';

export default Vue.extend({
  name: 'HButtonIcon',
  props: {
    iconName: {
      type: String,
      required: true,
    },
    tooltip: {
      type: String,
      default: '',
    },
    tooltipPlacement: {
      type: String,
      default: 'bottom',
    },
    color: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    placement() {
      return {
        [this.tooltipPlacement]: true,
      };
    },
  },
  data() {
    return {
      show: false,
    };
  },
});
